import { useCallback } from 'react';
import { PAPEvent } from '@dropbox/pap-events/base/event';
import { logPAPEvent } from 'js/sign-components/common/product-analytics-pipeline';
import { useHSUserOptional } from 'hellospa/common/hs-user';

/**
 * Returns a function that logs PAP events with the current user's userId and
 * foreignUserId attached automatically. Use this in HelloSPA components instead
 * of calling product-analytics-pipeline logPAPEvent directly when you want
 * user identifiers to be included.
 */
export function useLogPAPEvent(): (event: PAPEvent) => void {
  const user = useHSUserOptional();

  return useCallback(
    (event: PAPEvent) => {
      logPAPEvent(event, user?.dbxUserId ?? undefined, user?.guid);
    },
    [user?.guid, user?.dbxUserId],
  );
}
